import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-rotate-large.tsx
/**
* icon.24.rotate.large
*
* Keywords: diamond, refresh, sync, counterclockwise, update, reload, shape, geometric
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTExLjA1NCA5LjMzOGExLjUgMS41IDAgMCAxIDEuODkzIDBsLjExNS4xMDIgNC40OTkgNC41YTEuNSAxLjUgMCAwIDEgMCAyLjEybC00LjUgNC41YTEuNSAxLjUgMCAwIDEtMi4xMiAwbC00LjUtNC41YTEuNSAxLjUgMCAwIDEgMC0yLjEybDQuNS00LjV6bTEuMy44MWEuNS41IDAgMCAwLS43MDYgMGwtNC41IDQuNDk5YS41LjUgMCAwIDAgMCAuNzA3bDQuNSA0LjQ5OGEuNS41IDAgMCAwIC42MjguMDY0bC4wNzktLjA2NCA0LjQ5OC00LjQ5OGEuNS41IDAgMCAwIC4wNjQtLjYzbC0uMDY0LS4wNzh6TTkuNTI3IDQuMjdhMy41IDMuNSAwIDAgMSA0Ljk0OSAwTDE4IDcuNzk1VjUuNTAzYS41LjUgMCAwIDEgMSAwdjMuNWEuNS41IDAgMCAxLS41LjVIMTVhLjUuNSAwIDAgMSAwLTFoMi4yOTNsLTMuNTI1LTMuNTI2YTIuNSAyLjUgMCAwIDAtMy41MzUgMGwtNC4zOCA0LjM3N2EuNS41IDAgMCAxLS43MDYtLjcwN3oiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26677-58875
*/
const Icon24RotateLarge = memo(function Icon24RotateLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M11.054 9.338a1.5 1.5 0 0 1 1.893 0l.115.102 4.499 4.5a1.5 1.5 0 0 1 0 2.12l-4.5 4.5a1.5 1.5 0 0 1-2.12 0l-4.5-4.5a1.5 1.5 0 0 1 0-2.12l4.5-4.5zm1.3.81a.5.5 0 0 0-.706 0l-4.5 4.499a.5.5 0 0 0 0 .707l4.5 4.498a.5.5 0 0 0 .628.064l.079-.064 4.498-4.498a.5.5 0 0 0 .064-.63l-.064-.078zM9.527 4.27a3.5 3.5 0 0 1 4.949 0L18 7.795V5.503a.5.5 0 0 1 1 0v3.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h2.293l-3.525-3.526a2.5 2.5 0 0 0-3.535 0l-4.38 4.377a.5.5 0 0 1-.706-.707z"
		})
	});
});
//#endregion
export { Icon24RotateLarge };

//# sourceMappingURL=icon-24-rotate-large.js.map